import React, { useEffect, useState } from 'react';
import apiClient from '../services/apiClient';

// OWN-PARTY v1: User Management cell — "which Ref. Party is this full-access user personally" (drives the My report switch).
let mapPromise = null;
const loadMap = () => {
  if (!mapPromise) {
    mapPromise = apiClient.get('/users/own-ref-party')
      .then((r) => Object.fromEntries((r.data.data.assignments || []).map((a) => [a.userId, a.ownRefPartyId])))
      .catch(() => { mapPromise = null; return {}; });
  }
  return mapPromise;
};

export default function OwnRefPartyCell({ userId, refParties, locked, style }) {
  const [val, setVal] = useState('');
  const [err, setErr] = useState('');
  useEffect(() => { let alive = true; loadMap().then((m) => { if (alive) setVal(m[userId] ? String(m[userId]) : ''); }); return () => { alive = false; }; }, [userId]);
  if (locked) return <span style={{ color: 'var(--color-text-muted)' }}>—</span>;
  const change = async (e) => {
    const v = e.target.value;
    setErr('');
    try {
      await apiClient.patch(`/users/${userId}/own-ref-party`, { ownRefPartyId: v ? Number(v) : null });
      setVal(v);
      mapPromise = null;
    } catch (ex) { setErr((ex && ex.message) || 'Could not save'); }
  };
  return (
    <div>
      <select style={{ ...(style || {}), minWidth: 150 }} value={val} onChange={change} title="If this user is also a Ref. Party, choose it here. They get a 'My report' switch.">
        <option value="">— not a Ref. Party —</option>
        {(refParties || []).map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
      </select>
      {err && <div style={{ color: '#B42318', fontSize: 12 }}>{err}</div>}
    </div>
  );
}
